(function () {
  const storageKey = 'lp-measurement-unit';

  function getUnit() {
    try {
      const saved = sessionStorage.getItem(storageKey);
      if (saved === 'cm' || saved === 'ft') return saved;
      const legacy = JSON.parse(sessionStorage.getItem('caFiltersConfig') || 'null');
      if (legacy?.measurementUnit === 'ft') return 'ft';
    } catch (error) {
      // The default remains usable when session storage is unavailable.
    }
    return 'cm';
  }

  function formatMetric(value) {
    const number = Number(value);
    return Number.isFinite(number) ? String(number) : '';
  }

  function formatImperial(value) {
    const centimetres = Number(value);
    if (!Number.isFinite(centimetres)) return '';
    const totalInches = Math.round(centimetres / 2.54);
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;
    return `${feet}ft${inches ? ` ${inches}in` : ''}`;
  }

  function updateCards() {
    const unit = getUnit();
    const format = unit === 'ft' ? formatImperial : formatMetric;
    document.querySelectorAll('.lp-card-size[data-metric-length][data-metric-width]').forEach(card => {
      const length = format(card.dataset.metricLength);
      const width = format(card.dataset.metricWidth);
      if (length && width) card.textContent = `${length} x ${width}${unit === 'cm' ? ' cm' : ''}`;
    });
  }

  function setUnit(unit) {
    const next = unit === 'ft' ? 'ft' : 'cm';
    try { sessionStorage.setItem(storageKey, next); } catch (error) {}
    window.dispatchEvent(new CustomEvent('lp:measurement-unit-change', { detail: { unit: next } }));
  }

  window.lpMeasurements = { getUnit, setUnit, formatMetric, formatImperial, updateCards };
  window.addEventListener('lp:measurement-unit-change', updateCards);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCards);
  } else {
    updateCards();
  }
})();
